import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Portfolio from "./pages/PortfolioPage.jsx";
import Register from "./pages/Register";
import Login from "./pages/Login";

import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ProtectedRoute from "./components/common/ProtectedRoute";
import VerifyEmailOTP from "./pages/VerifyEmailOTP";
import AdminDashboard from "./pages/AdminDashboard.jsx";
import UserDashboard from "./pages/UserDashboard.jsx";
import SuperAdmin from "./pages/SuperAdmin.jsx";
import SuperAdminRoute from "./components/common/SuperAdminRoute.jsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GroupDetail from "./pages/GroupDetailPage.jsx";
import GroupSettingsPage from "./pages/GroupSettingsPage.jsx";
import FotographiyaMain from "./pages/Fotographiyamain.jsx";
import SelfieCapture from "./pages/SelfieCapture.jsx";
import DirectJoinPage from "./pages/DirectJoinPage.jsx";

function App() {
  return (
    <Router>
      <ToastContainer position="top-center" autoClose={3000} style={{ zIndex: 999999 }} />
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/join/:code" element={<DirectJoinPage />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-email-otp" element={<VerifyEmailOTP />} />
        <Route 
          path="/selfie-capture" 
          element={
            <ProtectedRoute>
              <SelfieCapture />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/capture-selfie" 
          element={
            <ProtectedRoute>
              <SelfieCapture />
            </ProtectedRoute>
          } 
        />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* 👑 Super Admin Platform Management (Strictly Protected) */}
        <Route
          path="/super-admin"
          element={
            <SuperAdminRoute>
              <SuperAdmin />
            </SuperAdminRoute>
          }
        />

        <Route
          path="/admin-dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-dashboard"
          element={
            <ProtectedRoute>
              <UserDashboard />
            </ProtectedRoute>
          }
        />

        <Route 
          path="/profile-setting" 
          element={
            <ProtectedRoute>
              <FotographiyaMain />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/group/:id" 
          element={
            <ProtectedRoute>
              <GroupDetail />
            </ProtectedRoute>
          } 
        />
        <Route
          path="/group-settings/:id"
          element={
            <ProtectedRoute>
              <GroupSettingsPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
